import { render } from "./EnbSidebar.vue?vue&type=template&id=10488a18&scoped=true"
import script from "./EnbSidebar.vue?vue&type=script&lang=js"
export * from "./EnbSidebar.vue?vue&type=script&lang=js"

import "./EnbSidebar.vue?vue&type=style&index=0&id=10488a18&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10488a18"]])

export default __exports__